import React, { useEffect, useState } from "react";
import api from "../../../services/api";
import { useAuth } from "../../../context/AuthContext";

const LowStockAlertBanner: React.FC = () => {
  const { token } = useAuth();
  const [alerts, setAlerts] = useState<any[]>([]);

  useEffect(() => {
    api.get("/inventory/low-stock", { headers: { Authorization: `Bearer ${token}` } })
      .then(res => setAlerts(res.data))
      .catch(() => setAlerts([]));
  }, [token]);

  if (!alerts.length) return null;

  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-700 p-4 mb-4 rounded">
      <strong>Low Stock Alert!</strong>
      <ul className="list-disc pl-5">
        {alerts.map((a, i) => (
          <li key={i}>{a.name} (SKU: {a.sku}) is low: {a.stock} left</li>
        ))}
      </ul>
    </div>
  );
};
export default LowStockAlertBanner;
